export const constraintsArray = [
  "numberOfTeachersAndTAsForSubjects",
  "numberOfTeachersAndTAsForElectives",
  "fixedTeachersAndTAsForSubjects",
  "fixedTeachersAndTAsForElectives",
  "multiPeriods",
  "preferredPeriods",
  "sharedRoomsForSubjects",
  "sharedRoomsForElectives",
  "totalPeriods",
  "jointClasses"
]

export const dataTableObjConstraints = [
  "numberOfTeachersAndTAsForSubject",
  "numberOfTeachersAndTAsForElective",
  "fixedTeachersAndTAsForSubject",
  "fixedTeachersAndTAsForElective",
  "multiPeriod",
  "preferredPeriod",
  "sharedRoomsForSubject",
  "sharedRoomsForElective",
  "totalPeriod",
  "jointClass"
]
